let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2g3L4")).then(() => parcelRequire('9bohR'));